import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Fa from 'react-fontawesome';
import styles from './styles.css';

// Import Selectors
import { getLoginErrors } from '../../AuthReducer';
import { loginWithEmailAndPassword, checkUsername } from '../../AuthActions';

class AuthenticatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      openFields: true,
      selectedUsername: null,
      hideForgotPassword: false,
      emailSent: null,
      selectedOrgId: null,
      organizations: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.buttonOpenFields = this.buttonOpenFields.bind(this);
    this.setSelectedUsername = this.setSelectedUsername.bind(this);
    this.setHideForgotPassword = this.setHideForgotPassword.bind(this);
    this.handleSelectUsername = this.handleSelectUsername.bind(this);
  }

  setHideForgotPassword(hideForgotPassword) {
    this.setState({ hideForgotPassword });
  }

  handleSelectUsername(data) {
    const { valid } = this.props;
    if (!valid) {
      return Promise.reject();
    }
    this.props.onLoading(true);
    this.setState({ error:  null, organizations: [], selectedOrgId: null });
    return new Promise((resolve, reject) => {
      const p = this.props.dispatch(checkUsername(data.username, data.organizationId));
      p.then(
        (user) => {
          if (user.sent) {
            // display sent email message
            this.setState({ emailSent: user.email });
            resolve(); // don't resolve, let the UI stay
          } else if (user.organizations?.length > 1 ) {
            // multiple orgs found
            this.props.onLoading(false);
            this.setState({ organizations: user.organizations, selectedOrgId: null });
            resolve();
          } else if (user.is_none_standard_user) {
            // need password to login
            this.props.onLoading(false);
            this.props.change('username', user.username);
            this.props.change('organizationId', null);
            this.setSelectedUsername(user.username);
            resolve(); // go to next step to enter passw0rd
          }
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
            e.username = e.message;
            this.setState({ error:  e.message, openFields: false, hideForgotPassword: true });
          }
          this.props.onLoading(false);
          reject(e);
          throw new SubmissionError(e);
        },
      );
    });

  }

  handleSubmit(data) {
    const { valid } = this.props;
    if (!valid) {
      return Promise.reject();
    }
    this.props.onLoading(true);
    this.setState({ error:  null });
    return new Promise((resolve, reject) => {
      const p = this.props.dispatch(loginWithEmailAndPassword(data.username, data.password));
      p.then(
        (user) => {
          this.props.onSuccess(user);
          this.props.onLoading(false);
          resolve(user);
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
            e.username = e.message;
            this.setState({ error:  e.message, openFields: false, hideForgotPassword: true });
          }
          this.props.onLoading(false);
          reject(e);
          throw new SubmissionError(e);
        },
      );
    });
  }

  setSelectedUsername(selectedUsername) {
    this.setState({ selectedUsername, emailSent: null });
  }


  buttonOpenFields() {
    this.props.change('organizationId', null);
    this.setState({ openFields: true, hideForgotPassword: false, selectedOrgId: null });
  }

  renderField({
    input, label, type, meta: { touched, error }, readOnly, disabled, options, componentClass,
  }) {
    const validationState = touched && error ? 'error' : null;

    const attrs = {};
    if (readOnly) {
      attrs.readOnly = true;
    }
    if (disabled) {
      attrs.disabled = true;
    }
    
    return (
      <FormGroup validationState={validationState}>
        {componentClass !== 'select' && <FormControl {...attrs} {...input} placeholder={label} type={type} />}
        {componentClass === 'select' &&
          <FormControl
            {...input}
            {...attrs}
            componentClass={componentClass}
          >
            <option>{label}</option>
            {options.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
          </FormControl>
        }
        <FormControl.Feedback />
        {touched && error && <HelpBlock className="text-left">{error}</HelpBlock>}
      </FormGroup>
    );
  }


  renderSelectorganizations() {
    const { submitting } = this.props;
    const { organizations, selectedOrgId } = this.state;
    if (!organizations || organizations.length === 0) {
      return null;
    }
    const options = map(organizations, (o) => {
      return {
        label: o.display_name,
        value: o._id,
      };
    });
    return (
      <div className="text-left">
        <p>Organization:</p>
        <Field disabled={submitting} options={options} name="organizationId" component={this.renderField} label="Please select an organization" componentClass="select" />
      </div>
    );
  }

  renderSelectUsername() {
    const { handleSubmit, submitting, valid } = this.props;
    const { openFields, organizations, selectedOrgId } = this.state;
    return (
      <div>
        <form method="post" action="/api/check-username" onSubmit={handleSubmit(this.handleSelectUsername)}>
          <div className={`animated ${openFields ? "fadeIn" : "fadeOut"}`}>
            <Field disabled={(submitting || organizations.length > 0)} name="username" type="text" component={this.renderField} label="Username" />
            <br />
            {this.renderSelectorganizations()}
            <button type="submit" disabled={(submitting || !valid)} className="btn btn-primary btn-lg btn-block">
              {submitting && <Fa name="spinner" spin />} Continue {!submitting && <Fa name="arrow-right" />}
            </button>
          </div>
        </form>
      </div>
    );
  }


  renderEmailSent() {
    const { emailSent } = this.state;
    return (
      <div className="text-left">
        <p>An email was sent to <code>{emailSent}</code></p>
        <p>Please check your email and follow the instructions.</p>
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting, isDark } = this.props;
    const { error, openFields, selectedUsername, hideForgotPassword, emailSent } = this.state;

    if (emailSent) {
      return this.renderEmailSent();
    }

    return (
      <div>
        
          {error !== null && !openFields && 
            <div className={`${isDark ? styles.warningNight : styles.warning} ${styles.warningPanel} animated fadeIn`}>
              <Fa name="exclamation-triangle fa-3x" />
              <div className={`${styles.warningText}`}>
              <div className={`${styles.warningBold}`}>User validation failed.</div><div>{error}</div>
              </div>
              <span className={`pull-right ${isDark ? styles.retryBtnNight : styles.retryBtn}`} onClick={this.buttonOpenFields}>RETRY</span>
            </div>
          }
          {!selectedUsername && this.renderSelectUsername()}
          {selectedUsername &&
            <form method="post" action="/api/login" onSubmit={handleSubmit(this.handleSubmit)}>
              {openFields && <div className={`animated ${openFields ? "fadeIn" : "fadeOut"}`}>
              <Field disabled readOnly name="username" type="text" component={this.renderField} label="Username" />
              <Field disabled={submitting} name="password" type="password" component={this.renderField} label="Password" />
              <br />
              <button type="submit" disabled={submitting} className="btn btn-primary btn-lg btn-block">
                Login
              </button>
              </div>}
            </form>
          }
          
        {!hideForgotPassword && <div className={styles.forgot}><br /><Link to="/reset">Forgot your password?</Link></div>}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    errors: getLoginErrors(state),
  };
}

AuthenticatePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  errors: PropTypes.shape({}).isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  location: PropTypes.shape({}).isRequired,
  isDark: PropTypes.bool,
};
AuthenticatePage.defaultProps = {
  onLoading: () => {},
  onSuccess: () => {},
  error: null,
  isDark: false,
};

AuthenticatePage.contextTypes = {
  router: PropTypes.object,
};

const validate = (values) => {
  const errors = {};
  if (!values.username) {
    errors.username = 'Username is required';
  }
  /*
  if (!values.password) {
    errors.password = 'Password is required';
  }
  */
  return errors;
};

const AuthenticateForm = reduxForm({
  form: 'authenticateForm',
  validate,
})(AuthenticatePage);

export default connect(mapStateToProps)(AuthenticateForm);
